import React from 'react'
import { Field, connect } from 'formik'
import { FormCheckbox, FormGroup, FormTextArea } from '..'
import { FormValues } from 'donate/types'
import { MessageFieldProps } from './types'

export const MessageField = ({ config }: MessageFieldProps): JSX.Element | null => {
  if (!config.showMessageField) return null
  return <MessageInput config={config} />
}

const MessageInput = connect<MessageFieldProps, FormValues>(({ config }) => {
  return (
    <div className="mb-6">
      {config.showDisplayName && (
        <Field name="display_name" placeholder={i18n.t('donate.attributes.display_name')} component={FormGroup} />
      )}

      <Field
        name="message"
        className="form-control donate-message-field"
        placeholder={i18n.t('donate.attributes.message')}
        component={FormTextArea}
      />
      <Field
        name="show_amount"
        className="inline-block mr-3"
        label={i18n.t('donate.show_amount.label')}
        component={FormCheckbox}
      />
      {!config.showDisplayName && (
        <Field name="show_user" className="inline-block" label={<ShowUserLabel />} component={FormCheckbox} />
      )}
    </div>
  )
})

const ShowUserLabel = connect<{}, FormValues>(({ formik }) => {
  const displayName = formik.values._company_donation
    ? formik.values.company_name
    : formik.values.first_name + ' ' + formik.values.last_name.substring(0, 1) + (formik.values.last_name && '.')
  const trimmedDisplayName = displayName.length > 18 ? displayName.substring(0, 18) + '...' : displayName

  return <>{i18n.t('donate.show_user.label') + (displayName.length > 1 ? ': ' : '') + trimmedDisplayName}</>
})
